import { useState } from 'react'
import { Trans } from 'react-i18next'

import { FunctionItem } from '@makyoapp/makyo-common'
import { ChevronSmallDown, ChevronSmallUp } from '@makyoapp/makyo-icon/icon'

import { cn } from '@/lib/cn'

type Props = {
  fnItem: FunctionItem
}

export const FnDescription = ({ fnItem }: Props) => {
  const [expandMore, setExpandMore] = useState(false)
  return (
    <div className={cn('text-light mb-6', expandMore && 'expanded')}>
      <div className='function-description'>
        <Trans i18nKey={`fn.${fnItem.id}.long`} />
      </div>{' '}
      <button
        className='link uppercase text-m-sm'
        onClick={() => {
          setExpandMore(!expandMore)
        }}
      >
        {!expandMore && (
          <span className='flex-c'>
            <Trans>Show More</Trans>
            <ChevronSmallDown />
          </span>
        )}
        {expandMore && (
          <span className='flex-c'>
            <Trans>Show Less</Trans>
            <ChevronSmallUp />
          </span>
        )}
      </button>
    </div>
  )
}
